const MOBILE_BREAKPOINT = 768;

function getSelectedTabIndex(container) {
  const tabItems = container.querySelectorAll('.hdt-tab-item');
  const selectedIndex = Array.from(tabItems).findIndex(item => item.getAttribute('tab-selected') === 'true');
  return selectedIndex >= 0 ? selectedIndex : 0;
}

function moveTabsButtonsForViewport(container, tabIndex = 0) {
  const tabsButtonsContainer = container.querySelector('.hdt-tabs-buttons');
  const tabsHead = container.querySelector('.hdt-tabs-head');
  const tabItems = container.querySelectorAll('.hdt-tab-item');
  const sectionRoot = container.querySelector('.hdt-tabs-collections-carousel');
  const mobileLayoutOrder = sectionRoot ? sectionRoot.dataset.mobileLayoutOrder : 'title_image_tabs_products';

  if (!tabsButtonsContainer || !tabsHead || tabItems.length === 0) return;

  const safeIndex = tabItems[tabIndex] ? tabIndex : 0;
  const selectedTab = tabItems[safeIndex];
  if (!selectedTab) return;

  // Always restore image/product order for desktop before applying mobile overrides.
  tabItems.forEach(tabItem => {
    const tabImage = tabItem.querySelector('.hdt-tab-image');
    const tabCarousel = tabItem.querySelector('.hdt-tab-carousel');
    if (tabImage && tabCarousel) {
      tabCarousel.insertAdjacentElement('beforebegin', tabImage);
    }
  });

  if (window.innerWidth <= MOBILE_BREAKPOINT) {
    const selectedTabImage = selectedTab.querySelector('.hdt-tab-image');
    const selectedTabCarousel = selectedTab.querySelector('.hdt-tab-carousel');

    if (mobileLayoutOrder === 'title_tabs_products_image') {
      if (selectedTabImage && selectedTabCarousel) {
        selectedTabCarousel.insertAdjacentElement('afterend', selectedTabImage);
      }

      if (selectedTabCarousel) {
        selectedTabCarousel.insertAdjacentElement('beforebegin', tabsButtonsContainer);
      } else {
        selectedTab.insertAdjacentElement('afterbegin', tabsButtonsContainer);
      }
    } else {
      if (selectedTabImage) {
        selectedTabImage.insertAdjacentElement('afterend', tabsButtonsContainer);
      } else if (selectedTabCarousel) {
        selectedTabCarousel.insertAdjacentElement('beforebegin', tabsButtonsContainer);
      } else {
        selectedTab.insertAdjacentElement('afterbegin', tabsButtonsContainer);
      }
    }
  } else {
    tabsHead.appendChild(tabsButtonsContainer);
  }
}

document.addEventListener('DOMContentLoaded', function() {
  
  
  const tabsContainers = document.querySelectorAll('.hdt-tabs-collections');
  
  tabsContainers.forEach(container => {
    const tabButtons = container.querySelectorAll('.hdt-tab-button');
    const tabItems = container.querySelectorAll('.hdt-tab-item');
    
    
    if (tabButtons.length > 0 && tabItems.length > 0) {
      tabButtons[0].setAttribute('aria-current', 'true');
      tabButtons[0].classList.add('hdt-bg-gray-700', 'hdt-text-white');
      tabButtons[0].classList.remove('hdt-bg-transparent', 'hdt-text-gray-700');

      // Show first tab content
      tabItems[0].setAttribute('tab-selected', 'true');
      tabItems[0].style.display = 'block';
      
      // Initialize slider for first tab
      const firstSlider = tabItems[0].querySelector('hdt-slider');
      if (firstSlider) {
        setTimeout(() => {
          createDotsForSlider(firstSlider);
        }, 150);
      }
      
      // Hide other tabs
      for (let i = 1; i < tabItems.length; i++) {
        tabItems[i].removeAttribute('tab-selected');
        tabItems[i].style.display = 'none';
      }

      // Apply configured mobile order for the selected tab
      moveTabsButtonsForViewport(container, 0);
      initializeTabsScroll(container);
    }
    
    // Add click event listeners to tab buttons
    tabButtons.forEach((button, index) => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Remove active state from all buttons
        tabButtons.forEach(btn => {
          btn.setAttribute('aria-current', 'false');
          btn.classList.remove('hdt-bg-gray-700', 'hdt-text-white');
          btn.classList.add('hdt-bg-transparent', 'hdt-text-gray-700');
        });
        
        // Hide all tab content
        tabItems.forEach(item => {
          item.removeAttribute('tab-selected');
          item.style.display = 'none';
        });
        
        // Set clicked button as active
        button.setAttribute('aria-current', 'true');
        button.classList.add('hdt-bg-gray-700', 'hdt-text-white');
        button.classList.remove('hdt-bg-transparent', 'hdt-text-gray-700');
        
        // Show corresponding tab content
        if (tabItems[index]) {
          tabItems[index].setAttribute('tab-selected', 'true');
          tabItems[index].style.display = 'block';

          // Apply configured mobile order after selecting a tab
          moveTabsButtonsForViewport(container, index);
          scrollTabIntoView(button);
          
          // Reinitialize slider for the active tab
          const slider = tabItems[index].querySelector('hdt-slider');
          if (slider) {
            // Trigger slider reinitialization if needed
            const event = new CustomEvent('slider:reinit', { detail: { slider: slider } });
            slider.dispatchEvent(event);
            
            // Initialize dots for this specific slider after tab is visible
            setTimeout(() => {
              createDotsForSlider(slider);
            }, 150);
          }
        }
      });
    });
  });
});

document.addEventListener('shopify:section:load', function(event) {
  
  const newContainers = event.target.querySelectorAll('.hdt-tabs-collections');
  
  newContainers.forEach(container => {
    const tabButtons = container.querySelectorAll('.hdt-tab-button');
    const tabItems = container.querySelectorAll('.hdt-tab-item');
    
    // Initialize first tab as active
    if (tabButtons.length > 0 && tabItems.length > 0) {
      // Set first button as active
      tabButtons[0].setAttribute('aria-current', 'true');
      tabButtons[0].classList.add('hdt-bg-gray-700', 'hdt-text-white');
      tabButtons[0].classList.remove('hdt-bg-transparent', 'hdt-text-gray-700');

      // Show first tab content
      tabItems[0].setAttribute('tab-selected', 'true');
      tabItems[0].style.display = 'block';
      
      // Initialize slider for first tab
      const firstSlider = tabItems[0].querySelector('hdt-slider');
      if (firstSlider) {
        setTimeout(() => {
          createDotsForSlider(firstSlider);
        }, 150);
      }
      
      // Hide other tabs
      for (let i = 1; i < tabItems.length; i++) {
        tabItems[i].removeAttribute('tab-selected');
        tabItems[i].style.display = 'none';
      }

      // Apply configured mobile order for the selected tab
      moveTabsButtonsForViewport(container, 0);
      initializeTabsScroll(container);
    }
    
    // Add click event listeners to tab buttons
    tabButtons.forEach((button, index) => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Remove active state from all buttons
        tabButtons.forEach(btn => {
          btn.setAttribute('aria-current', 'false');
          btn.classList.remove('hdt-bg-gray-700', 'hdt-text-white');
          btn.classList.add('hdt-bg-transparent', 'hdt-text-gray-700');
        });
        
        // Hide all tab content
        tabItems.forEach(item => {
          item.removeAttribute('tab-selected');
          item.style.display = 'none';
        });
        
        // Set clicked button as active
        button.setAttribute('aria-current', 'true');
        button.classList.add('hdt-bg-gray-700', 'hdt-text-white');
        button.classList.remove('hdt-bg-transparent', 'hdt-text-gray-700');
        
        // Show corresponding tab content
        if (tabItems[index]) {
          tabItems[index].setAttribute('tab-selected', 'true');
          tabItems[index].style.display = 'block';

          // Apply configured mobile order after selecting a tab
          moveTabsButtonsForViewport(container, index);
          scrollTabIntoView(button);
          
          // Reinitialize slider for the active tab
          const slider = tabItems[index].querySelector('hdt-slider');
          if (slider) {
            // Trigger slider reinitialization if needed
            const event = new CustomEvent('slider:reinit', { detail: { slider: slider } });
            slider.dispatchEvent(event);
            
            // Initialize dots for this specific slider after tab is visible
            setTimeout(() => {
              createDotsForSlider(slider);
            }, 150);
          }
        }
      });
    });
  });
});

// Function to scroll tab button into view (centered in mobile)
function scrollTabIntoView(button) {
  const tabsContainer = button.closest('.hdt-tabs-buttons');
  if (!tabsContainer) return;
  
  // Only apply on mobile screens
  if (window.innerWidth <= MOBILE_BREAKPOINT) {
    const containerWidth = tabsContainer.offsetWidth;
    const buttonLeft = button.offsetLeft;
    const buttonWidth = button.offsetWidth;
    
    // Calculate scroll position to center the button
    const scrollPosition = buttonLeft - (containerWidth / 2) + (buttonWidth / 2);
    
    // Smooth scroll to position
    tabsContainer.scrollTo({
      left: scrollPosition,
      behavior: 'smooth'
    });
    
  }
}

// Function to initialize tabs scroll position with padding for first tab
function initializeTabsScroll(container) {
  const tabsButtonsContainer = container.querySelector('.hdt-tabs-buttons');
  
  if (tabsButtonsContainer && window.innerWidth <= MOBILE_BREAKPOINT) {
    // Reset scroll position to start
    tabsButtonsContainer.scrollLeft = 0;
  }
}

// Add touch/swipe support for tabs in mobile
function initializeTouchSupport() {
  const tabsButtons = document.querySelectorAll('.hdt-tabs-buttons');
  
  tabsButtons.forEach(container => {
    let isDown = false;
    let startX;
    let scrollLeft;
    
    container.addEventListener('mousedown', (e) => {
      if (window.innerWidth > 768) return; // Only on mobile
      isDown = true;
      container.style.cursor = 'grabbing';
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
    });
    
    container.addEventListener('mouseleave', () => {
      isDown = false;
      container.style.cursor = 'grab';
    });
    
    container.addEventListener('mouseup', () => {
      isDown = false;
      container.style.cursor = 'grab';
    });
    
    container.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startX) * 2; // Scroll speed multiplier
      container.scrollLeft = scrollLeft - walk;
    });
    
    // Touch events for mobile with improved scroll control
    let touchStartX = 0;
    let touchStartY = 0;
    let touchScrollLeft = 0;
    let isScrolling = false;
    
    container.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].pageX;
      touchStartY = e.touches[0].pageY;
      touchScrollLeft = container.scrollLeft;
      isScrolling = false;
    }, { passive: true });
    
    container.addEventListener('touchend', () => {
      // Resetear variables al finalizar el toque
      touchStartX = 0;
      touchStartY = 0;
      isScrolling = false;
    }, { passive: true });
    
    container.addEventListener('touchmove', (e) => {
      const touchX = e.touches[0].pageX;
      const touchY = e.touches[0].pageY;
      const deltaX = Math.abs(touchX - touchStartX);
      const deltaY = Math.abs(touchY - touchStartY);
      
      // Determinar dirección si aún no se ha determinado
      if (!isScrolling && (deltaX > 10 || deltaY > 10)) {
        isScrolling = deltaX > deltaY ? 'horizontal' : 'vertical';
      }
      
      // Si el deslizamiento es principalmente vertical
      if (isScrolling === 'vertical') {
        // Verificar si el scroll horizontal está en el límite
        const isAtLeftEdge = container.scrollLeft <= 0 && (touchX - touchStartX) > 0;
        const isAtRightEdge = container.scrollLeft >= container.scrollWidth - container.clientWidth - 1 && (touchX - touchStartX) < 0;
        
        // Si está en el límite o el movimiento es claramente vertical, permitir scroll vertical
        if (isAtLeftEdge || isAtRightEdge || deltaY > deltaX * 1.5) {
          // Permitir que el scroll vertical funcione normalmente
          return;
        }
      }
      
      // Si el deslizamiento es principalmente horizontal, manejar el scroll horizontal
      if (isScrolling === 'horizontal') {
        // Verificar si el scroll horizontal está en el límite
        const isAtLeftEdge = container.scrollLeft <= 0 && (touchX - touchStartX) > 0;
        const isAtRightEdge = container.scrollLeft >= container.scrollWidth - container.clientWidth - 1 && (touchX - touchStartX) < 0;
        
        // Si está en el límite y el usuario intenta deslizar más, permitir scroll vertical
        if ((isAtLeftEdge || isAtRightEdge) && deltaY > deltaX) {
          // Permitir scroll vertical cuando el slider está en el límite
          return;
        }
        
        const walk = (touchStartX - touchX);
        container.scrollLeft = touchScrollLeft + walk;
      }
    }, { passive: true });
    
  });
}

// Prevenir scroll horizontal de body en mobile
if (window.innerWidth <= MOBILE_BREAKPOINT) {
  document.body.style.overflowX = 'hidden';
  document.documentElement.style.overflowX = 'hidden';
}

let tabsLayoutResizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(tabsLayoutResizeTimeout);
  tabsLayoutResizeTimeout = setTimeout(() => {
    document.querySelectorAll('.hdt-tabs-collections').forEach(container => {
      moveTabsButtonsForViewport(container, getSelectedTabIndex(container));
    });
  }, 150);
});

// Initialize touch support on load
document.addEventListener('DOMContentLoaded', function() {
  initializeTouchSupport();
  // Also initialize scroll position for all containers
  document.querySelectorAll('.hdt-tabs-collections').forEach(container => {
    initializeTabsScroll(container);
  });
});

// Reinitialize touch support after section reload
document.addEventListener('shopify:section:load', function() {
  setTimeout(() => {
    initializeTouchSupport();
    // Also reinitialize scroll position for all containers
    document.querySelectorAll('.hdt-tabs-collections').forEach(container => {
      initializeTabsScroll(container);
    });
  }, 300);
});

// Handle section reorder and select events for admin
document.addEventListener('shopify:section:reorder', function(event) {
  setTimeout(() => {
    initializeTabsCarousel();
  }, 100);
});

document.addEventListener('shopify:section:select', function(event) {
  setTimeout(() => {
    initializeTabsCarousel();
  }, 100);
});

// Handle block select events
document.addEventListener('shopify:block:select', function(event) {
  setTimeout(() => {
    initializeTabsCarousel();
  }, 100);
});

// Function to initialize tabs carousel
function initializeTabsCarousel() {
  const tabsContainers = document.querySelectorAll('.hdt-tabs-collections');
  
  tabsContainers.forEach(container => {
    const tabButtons = container.querySelectorAll('.hdt-tab-button');
    const tabItems = container.querySelectorAll('.hdt-tab-item');
    
    // Initialize first tab as active
    if (tabButtons.length > 0 && tabItems.length > 0) {
      // Set first button as active
      tabButtons[0].setAttribute('aria-current', 'true');
      tabButtons[0].classList.add('hdt-bg-gray-700', 'hdt-text-white');
      tabButtons[0].classList.remove('hdt-bg-transparent', 'hdt-text-gray-700');

      // Show first tab content
      tabItems[0].setAttribute('tab-selected', 'true');
      tabItems[0].style.display = 'block';
      
      // Initialize slider for first tab
      const firstSlider = tabItems[0].querySelector('hdt-slider');
      if (firstSlider) {
        setTimeout(() => {
          createDotsForSlider(firstSlider);
        }, 150);
      }
      
      // Hide other tabs
      for (let i = 1; i < tabItems.length; i++) {
        tabItems[i].removeAttribute('tab-selected');
        tabItems[i].style.display = 'none';
      }

      moveTabsButtonsForViewport(container, 0);
      initializeTabsScroll(container);
    }
    
    // Reinitialize sliders in all tabs (only visible ones)
    tabItems.forEach((tabItem, index) => {
      // Only process visible tabs
      if (tabItem.getAttribute('tab-selected') !== 'true') {
        return;
      }
      const slider = tabItem.querySelector('hdt-slider');
      if (slider) {
        // Force slider reinitialization
        const event = new CustomEvent('slider:reinit', { detail: { slider: slider } });
        slider.dispatchEvent(event);
        
        // Force CSS classes to be applied
        const container = slider.querySelector('.hdt-slider__container');
        if (container) {
          // Force recalculation of slide sizes
          container.style.display = 'none';
          container.offsetHeight; // Trigger reflow
          container.style.display = 'flex';
        }
        
        // Apply slide sizes to individual slides
        const slides = slider.querySelectorAll('.hdt-slider__slide');
        
        // Get current screen size to calculate proper slide size
        const screenWidth = window.innerWidth;
        const isDesktop = screenWidth >= 1150;
        const isTablet = screenWidth >= 768 && screenWidth < 1150;
        const sliderClassList = slider.classList;
        
        let currentSlidesPerView = 1;
        if (isDesktop) {
          if (sliderClassList.contains('lg:hdt-slides-6')) currentSlidesPerView = 6;
          else if (sliderClassList.contains('lg:hdt-slides-5')) currentSlidesPerView = 5;
          else if (sliderClassList.contains('lg:hdt-slides-4')) currentSlidesPerView = 4;
          else if (sliderClassList.contains('lg:hdt-slides-3')) currentSlidesPerView = 3;
          else if (sliderClassList.contains('lg:hdt-slides-2')) currentSlidesPerView = 2;
          else if (sliderClassList.contains('lg:hdt-slides-1')) currentSlidesPerView = 1;
        } else if (isTablet) {
          if (sliderClassList.contains('md:hdt-slides-6')) currentSlidesPerView = 6;
          else if (sliderClassList.contains('md:hdt-slides-5')) currentSlidesPerView = 5;
          else if (sliderClassList.contains('md:hdt-slides-4')) currentSlidesPerView = 4;
          else if (sliderClassList.contains('md:hdt-slides-3')) currentSlidesPerView = 3;
          else if (sliderClassList.contains('md:hdt-slides-2')) currentSlidesPerView = 2;
          else if (sliderClassList.contains('md:hdt-slides-1')) currentSlidesPerView = 1;
        } else {
          if (sliderClassList.contains('hdt-slides-6')) currentSlidesPerView = 6;
          else if (sliderClassList.contains('hdt-slides-5')) currentSlidesPerView = 5;
          else if (sliderClassList.contains('hdt-slides-4')) currentSlidesPerView = 4;
          else if (sliderClassList.contains('hdt-slides-3')) currentSlidesPerView = 3;
          else if (sliderClassList.contains('hdt-slides-2')) currentSlidesPerView = 2;
          else if (sliderClassList.contains('hdt-slides-1')) currentSlidesPerView = 1;
        }
        
        slides.forEach(slide => {
          // Force CSS variable recalculation
          slide.style.flex = '0 0 var(--slide-size)';
          slide.style.width = 'var(--slide-size)';
          slide.style.minWidth = 'var(--slide-size)';
        });
        
        // Create dots if they don't exist and dotUI is enabled
        const dotsContainer = slider.querySelector('.hdt-slider__dots');
        if (dotsContainer && slides.length > 0) {
          // Clear existing dots
          dotsContainer.innerHTML = '';
          
          // Calculate how many slides are visible at once based on screen size
          const sliderClassList = slider.classList;
          let slidesPerView = 1;
          
          // Detect screen size
          const screenWidth = window.innerWidth;
          const isDesktop = screenWidth >= 1150;
          const isTablet = screenWidth >= 768 && screenWidth < 1150;
          
          // Extract slides per view from CSS classes based on screen size
          if (isDesktop) {
            // Check for lg: classes first
            if (sliderClassList.contains('lg:hdt-slides-6')) slidesPerView = 6;
            else if (sliderClassList.contains('lg:hdt-slides-5')) slidesPerView = 5;
            else if (sliderClassList.contains('lg:hdt-slides-4')) slidesPerView = 4;
            else if (sliderClassList.contains('lg:hdt-slides-3')) slidesPerView = 3;
            else if (sliderClassList.contains('lg:hdt-slides-2')) slidesPerView = 2;
            else if (sliderClassList.contains('lg:hdt-slides-1')) slidesPerView = 1;
          } else if (isTablet) {
            // Check for md: classes
            if (sliderClassList.contains('md:hdt-slides-6')) slidesPerView = 6;
            else if (sliderClassList.contains('md:hdt-slides-5')) slidesPerView = 5;
            else if (sliderClassList.contains('md:hdt-slides-4')) slidesPerView = 4;
            else if (sliderClassList.contains('md:hdt-slides-3')) slidesPerView = 3;
            else if (sliderClassList.contains('md:hdt-slides-2')) slidesPerView = 2;
            else if (sliderClassList.contains('md:hdt-slides-1')) slidesPerView = 1;
          } else {
            // Mobile - check base classes (exact match, not includes)
            if (sliderClassList.contains('hdt-slides-6')) slidesPerView = 6;
            else if (sliderClassList.contains('hdt-slides-5')) slidesPerView = 5;
            else if (sliderClassList.contains('hdt-slides-4')) slidesPerView = 4;
            else if (sliderClassList.contains('hdt-slides-3')) slidesPerView = 3;
            else if (sliderClassList.contains('hdt-slides-2')) slidesPerView = 2;
            else if (sliderClassList.contains('hdt-slides-1')) slidesPerView = 1;
          }
          
          // Calculate number of pages needed
          const totalSlides = slides.length;
          const totalPages = Math.ceil(totalSlides / slidesPerView);
          
          // Always create dots (simplified for debugging)
          for (let i = 0; i < totalPages; i++) {
            const dot = document.createElement('button');
            dot.className = 'hdt-slider__pagination-dot';
            dot.setAttribute('data-page', i);
            dot.setAttribute('aria-label', `Go to page ${i + 1}`);
            dot.style.cssText = 'width: 6.07px; height: 6.07px; border-radius: 50%; background-color: #ccc; border: none; cursor: pointer; margin: 0 4px;';
            if (i === 0) {
              dot.classList.add('hdt-slider__pagination-dot--active');
              dot.style.backgroundColor = '#000';
            }
            dotsContainer.appendChild(dot);
          }
          
          // Add click handlers to dots
          const dots = dotsContainer.querySelectorAll('.hdt-slider__pagination-dot');
          
          dots.forEach((dot, pageIndex) => {
            dot.addEventListener('click', () => {
              // Remove active class from all dots
              dots.forEach(d => {
                d.classList.remove('hdt-slider__pagination-dot--active');
                d.style.backgroundColor = '#ccc';
              });
              
              // Add active class to clicked dot
              dot.classList.add('hdt-slider__pagination-dot--active');
              dot.style.backgroundColor = '#000';
              
              // Calculate which slides to show
              const startIndex = pageIndex * slidesPerView;
              const endIndex = Math.min(startIndex + slidesPerView, totalSlides);
              
              // Hide all slides first
              slides.forEach(slide => {
                slide.style.display = 'none';
              });
              
              // Show slides for this page
              for (let i = startIndex; i < endIndex; i++) {
                if (slides[i]) {
                  slides[i].style.display = 'block';
                }
              }
              
            });
          });
        }
        
        // Also trigger a resize event to recalculate dimensions
        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
        }, 50);
      }
    });
  });
}

// Helper function to calculate slides per view
function calculateSlidesPerView(slider) {
  const classList = slider.classList;
  const screenWidth = window.innerWidth;
  const isDesktop = screenWidth >= 1150;
  const isTablet = screenWidth >= 768 && screenWidth < 1150;

  const prefix = isDesktop ? 'lg:' : isTablet ? 'md:' : '';

  for (let n = 6; n >= 1; n--) {
    if (classList.contains(`${prefix}hdt-slides-${n}`)) return n;
  }
  return 1;
}

// Function to create dots for a specific slider
function createDotsForSlider(slider) {
  if (!slider) {
    return;
  }
  
  // Check if slider is in a visible tab
  const tabItem = slider.closest('.hdt-tab-item');
  const isTabVisible = tabItem && (tabItem.style.display !== 'none' && tabItem.getAttribute('tab-selected') === 'true');
  
  // Only process if slider is visible or if we're forcing initialization
  const dotsContainer = slider.querySelector('.hdt-slider__dots');
  if (!dotsContainer) {
    return;
  }
  
  // Clear existing dots
  dotsContainer.innerHTML = '';
  
  // Get slides
  const slides = slider.querySelectorAll('.hdt-slider__slide');
  
  if (slides.length === 0) {
    return;
  }
  
  // Calculate slides per view based on screen size
  const slidesPerView = calculateSlidesPerView(slider);
  const screenWidth = window.innerWidth;
  const isDesktop = screenWidth >= 1150;
  
  const totalPages = Math.ceil(slides.length / slidesPerView);
  
  // Only hide/show slides if tab is visible
  if (isTabVisible) {
    // Show only the first page of slides initially
    const initialStartIndex = 0;
    const initialEndIndex = Math.min(initialStartIndex + slidesPerView, slides.length);
    
    // Set initial transform to show first page
    const sliderContainer = slider.querySelector('.hdt-slider__container');
    if (sliderContainer) {
      // NO TRANSITION - instant movement to reduce lag
      sliderContainer.style.transition = 'none';
      sliderContainer.style.transform = 'translateX(0px)';
      
      // Ensure all slides are visible (they're just positioned off-screen)
      slides.forEach((slide) => {
        slide.style.display = '';
        slide.style.visibility = '';
        slide.style.opacity = '';
      });
    } else {
      // Fallback: if no container, use the old method
      slides.forEach((slide, slideIndex) => {
        if (slideIndex >= initialEndIndex) {
          slide.style.display = 'none';
          slide.style.visibility = 'hidden';
          slide.style.opacity = '0';
        } else {
          slide.style.display = 'block';
          slide.style.visibility = 'visible';
          slide.style.opacity = '1';
        }
      });
    }
  }
  
  // Create dots
  for (let i = 0; i < totalPages; i++) {
    const dot = document.createElement('button');
    dot.className = 'hdt-slider__pagination-dot';
    dot.setAttribute('data-page', i);
    dot.setAttribute('aria-label', `Go to page ${i + 1}`);
    
    if (i === 0) {
      dot.classList.add('hdt-slider__pagination-dot--active');
      dot.style.backgroundColor = '#000';
      dot.style.transform = 'scale(1.2)';
    } else {
      dot.style.backgroundColor = '#ccc';
      dot.style.transform = 'scale(1)';
    }
    
    dotsContainer.appendChild(dot);
  }
  
  // Function to navigate to a specific page
  const navigateToPage = (targetPageIndex) => {
    const currentSlidesPerView = calculateSlidesPerView(slider);
    const totalPages = Math.ceil(slides.length / currentSlidesPerView);
    
    // Clamp page index to valid range
    if (targetPageIndex < 0) targetPageIndex = 0;
    if (targetPageIndex >= totalPages) targetPageIndex = totalPages - 1;
    
    // Update dot states
    const allDots = dotsContainer.querySelectorAll('.hdt-slider__pagination-dot');
    allDots.forEach((d, idx) => {
      if (idx === targetPageIndex) {
        d.classList.add('hdt-slider__pagination-dot--active');
        d.style.backgroundColor = '#000';
        d.style.transform = 'scale(1.2)';
      } else {
        d.classList.remove('hdt-slider__pagination-dot--active');
        d.style.backgroundColor = '#ccc';
        d.style.transform = 'scale(1)';
      }
    });
    
    // Update navigation button states
    const prevButton = slider.querySelector('.hdt-slider__button--prev');
    const nextButton = slider.querySelector('.hdt-slider__button--next');
    
    if (prevButton) {
      if (targetPageIndex === 0) {
        prevButton.setAttribute('disabled', 'disabled');
        prevButton.disabled = true;
      } else {
        prevButton.removeAttribute('disabled');
        prevButton.disabled = false;
      }
    }
    
    if (nextButton) {
      if (targetPageIndex >= totalPages - 1) {
        nextButton.setAttribute('disabled', 'disabled');
        nextButton.disabled = true;
      } else {
        nextButton.removeAttribute('disabled');
        nextButton.disabled = false;
      }
    }
    
    // Instead of hiding slides, move the container using transform
    // This preserves the flex layout
    const sliderContainer = slider.querySelector('.hdt-slider__container');
    if (sliderContainer) {
      // Calculate the transform offset based on actual slide width
      // Get the first slide to calculate its width
      const firstSlide = slides[0];
      if (!firstSlide) return targetPageIndex;
      
      // Get spacing from slider element (where CSS variable is defined)
      const slideSpacing = parseFloat(getComputedStyle(slider).getPropertyValue('--slide-spacing')) || 0;
      
      // Calculate slide width including spacing
      // Each slide has padding-inline-start equal to --slide-spacing
      const slideWidth = firstSlide.offsetWidth;
      const slideWidthWithSpacing = slideWidth; // offsetWidth already includes padding
      
      // Check if we're on mobile
      const isMobile = window.innerWidth <= 768;
      
      // Calculate how much to move: slide width * slides per view * page index
      const translateX = -(targetPageIndex * currentSlidesPerView * slideWidthWithSpacing);

      // Use smooth transition for better UX
      sliderContainer.style.transition = 'transform 0.3s ease-out';
      sliderContainer.style.transform = `translateX(${translateX}px)`;
      
      // Ensure all slides are visible (they're just positioned off-screen)
      slides.forEach((slide, slideIndex) => {
        slide.style.display = '';
        slide.style.visibility = '';
        slide.style.opacity = '';
      });
    } else {
      // Fallback: if no container, use the old method
      const startIndex = targetPageIndex * currentSlidesPerView;
      const endIndex = Math.min(startIndex + currentSlidesPerView, slides.length);
      
      slides.forEach((slide, slideIndex) => {
        if (slideIndex >= startIndex && slideIndex < endIndex) {
          slide.style.display = 'block';
          slide.style.visibility = 'visible';
          slide.style.opacity = '1';
        } else {
          slide.style.display = 'none';
          slide.style.visibility = 'hidden';
          slide.style.opacity = '0';
        }
      });
    }
    
    return targetPageIndex;
  };
  
  // Track current page - initialize to first page
  let currentPageIndex = 0;
  
  // Function to recalculate position on resize
  const recalculatePosition = () => {
    navigateToPage(currentPageIndex);
  };
  
  // Add resize listener to recalculate position
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      recalculatePosition();
    }, 250);
  });
  
  // Initialize navigation buttons state
  navigateToPage(0);
  
  // Add click handlers for dots
  const dots = dotsContainer.querySelectorAll('.hdt-slider__pagination-dot');
  dots.forEach((dot, pageIndex) => {
    dot.addEventListener('click', () => {
      currentPageIndex = navigateToPage(pageIndex);
    });
  });

  // Sync active dot with actual container transform (handles native swipe/drag too)
  const readTranslateX = (el) => {
    // Prefer computed style — always returns a matrix regardless of how the transform was written
    const computed = getComputedStyle(el).transform;
    if (computed && computed !== 'none') {
      const m = computed.match(/matrix(?:3d)?\(([^)]+)\)/);
      if (m) {
        const values = m[1].split(',').map(v => parseFloat(v.trim()));
        // matrix(a,b,c,d,tx,ty) → tx at 4; matrix3d → tx at 12
        return values.length === 6 ? values[4] : (values[12] || 0);
      }
    }
    // Fallback to inline style
    const inline = el.style.transform || '';
    const im = inline.match(/translate(?:3d|X)?\((-?\d+\.?\d*)/);
    return im ? parseFloat(im[1]) : 0;
  };

  const getSlideWidth = () => {
    for (const s of slides) {
      if (s && s.offsetWidth) return s.offsetWidth;
    }
    return 0;
  };

  const syncActiveDotFromTransform = () => {
    const container = slider.querySelector('.hdt-slider__container');
    if (!container) return;
    const slideWidth = getSlideWidth();
    if (!slideWidth) return;
    const translateX = readTranslateX(container);
    const currentSlidesPerView = calculateSlidesPerView(slider);
    const totalPages = Math.ceil(slides.length / currentSlidesPerView);
    const rawPage = -translateX / (slideWidth * currentSlidesPerView);
    const pageIndex = Math.max(0, Math.min(Math.round(rawPage), totalPages - 1));

    const allDots = dotsContainer.querySelectorAll('.hdt-slider__pagination-dot');
    allDots.forEach((d, idx) => {
      const isActive = idx === pageIndex;
      d.classList.toggle('hdt-slider__pagination-dot--active', isActive);
      d.style.backgroundColor = isActive ? '#000' : '#ccc';
      d.style.transform = isActive ? 'scale(1.2)' : 'scale(1)';
    });
    currentPageIndex = pageIndex;
  };

  const containerForObserver = slider.querySelector('.hdt-slider__container');
  const viewportForSync = slider.querySelector('.hdt-slider__viewport');
  if (containerForObserver) {
    let rafId = null;
    const triggerSync = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(syncActiveDotFromTransform);
    };

    const transformObserver = new MutationObserver(triggerSync);
    transformObserver.observe(containerForObserver, {
      attributes: true,
      attributeFilter: ['style'],
    });
    containerForObserver.addEventListener('transitionend', (e) => {
      if (e.propertyName === 'transform') syncActiveDotFromTransform();
    });

    // Explicit resync after user gestures (covers cases where the native slider
    // snaps via rAF/setTimeout without firing a detectable style mutation)
    if (viewportForSync) {
      ['touchend', 'touchcancel', 'pointerup', 'pointercancel', 'mouseup', 'mouseleave'].forEach(evt => {
        viewportForSync.addEventListener(evt, () => {
          syncActiveDotFromTransform();
          setTimeout(syncActiveDotFromTransform, 50);
          setTimeout(syncActiveDotFromTransform, 350);
        }, { passive: true });
      });
    }
  }
  
  // Add click handlers for navigation arrows
  // Use event delegation to catch clicks on navigation buttons
  slider.addEventListener('click', (e) => {
    const target = e.target.closest('.hdt-slider__button--prev, .hdt-slider__button--next');
    if (!target) return;
    
    e.preventDefault();
    e.stopPropagation();
    
    if (target.classList.contains('hdt-slider__button--prev')) {
      currentPageIndex = navigateToPage(currentPageIndex - 1);
    } else if (target.classList.contains('hdt-slider__button--next')) {
      currentPageIndex = navigateToPage(currentPageIndex + 1);
    }
  });
  
  // Add touch/swipe support to detect when user swipes the slider
  let touchStartX = 0;
  let touchStartY = 0;
  let touchEndX = 0;
  let isDragging = false;
  let dragStartX = 0;
  let initialTranslate = 0;
  let scrollDirection = null;
  const threshold = 10; // Píxeles mínimos para determinar dirección
  
  const viewport = slider.querySelector('.hdt-slider__viewport');
  if (viewport) {
    // Touch events for mobile
    viewport.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      scrollDirection = null;
      const sliderContainer = slider.querySelector('.hdt-slider__container');
      if (sliderContainer) {
        const transform = sliderContainer.style.transform;
        if (transform) {
          const match = transform.match(/translateX\((-?\d+\.?\d*)px\)/);
          if (match) {
            initialTranslate = parseFloat(match[1]);
          }
        }
        // Disable transition during drag for smooth following
        sliderContainer.style.transition = 'none';
      }
    }, { passive: true });
    
    viewport.addEventListener('touchmove', (e) => {
      if (window.innerWidth <= 768) {
        if (!touchStartX || !touchStartY) return;
        
        const currentX = e.touches[0].clientX;
        const currentY = e.touches[0].clientY;
        const diffX = currentX - touchStartX;
        const diffY = currentY - touchStartY;
        const absDiffX = Math.abs(diffX);
        const absDiffY = Math.abs(diffY);
        
        // Determinar dirección si aún no se ha determinado
        if (!scrollDirection && (absDiffX > threshold || absDiffY > threshold)) {
          scrollDirection = absDiffX > absDiffY ? 'horizontal' : 'vertical';
        }
        
        // Si el deslizamiento es principalmente vertical, permitir scroll vertical
        if (scrollDirection === 'vertical') {
          // Verificar si el slider está en el límite
          const sliderContainer = slider.querySelector('.hdt-slider__container');
          if (sliderContainer) {
            const slidesPerView = calculateSlidesPerView(slider);
            const totalPages = Math.ceil(slides.length / slidesPerView);
            const firstSlide = slides[0];
            
            if (firstSlide) {
              const slideWidth = firstSlide.offsetWidth;
              const maxTranslate = -(totalPages - 1) * slidesPerView * slideWidth;
              const isAtLeftEdge = initialTranslate >= 0 && diffX > 0;
              const isAtRightEdge = initialTranslate <= maxTranslate && diffX < 0;
              
              // Si está en el límite o el movimiento es claramente vertical, permitir scroll vertical
              if (isAtLeftEdge || isAtRightEdge || absDiffY > absDiffX * 1.5) {
                // Permitir que el scroll vertical funcione normalmente
                return;
              }
            }
          }
        }
        
        // Si el deslizamiento es principalmente horizontal, manejar el slider
        if (scrollDirection === 'horizontal' || !scrollDirection) {
          const sliderContainer = slider.querySelector('.hdt-slider__container');
          if (sliderContainer) {
            const diff = touchStartX - currentX;
            const newTranslate = initialTranslate - diff;
            // Smooth following during swipe
            sliderContainer.style.transition = 'none';
            sliderContainer.style.transform = `translateX(${newTranslate}px)`;
          }
        }
      }
    }, { passive: true });
    
    viewport.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].clientX;
      // Solo manejar swipe si el deslizamiento fue principalmente horizontal
      if (scrollDirection === 'horizontal' || (!scrollDirection && Math.abs(touchStartX - touchEndX) > Math.abs(touchStartY - (e.changedTouches[0].clientY || touchStartY)))) {
        handleSwipe();
      }
      // Resetear variables
      touchStartX = 0;
      touchStartY = 0;
      scrollDirection = null;
    }, { passive: true });
    
    // Mouse drag for desktop
    viewport.addEventListener('mousedown', (e) => {
      isDragging = true;
      dragStartX = e.clientX;
      const sliderContainer = slider.querySelector('.hdt-slider__container');
      if (sliderContainer) {
        const transform = sliderContainer.style.transform;
        if (transform) {
          const match = transform.match(/translateX\((-?\d+\.?\d*)px\)/);
          if (match) {
            initialTranslate = parseFloat(match[1]);
          }
        }
        // Disable transition during drag for smooth following
        sliderContainer.style.transition = 'none';
      }
      viewport.style.cursor = 'grabbing';
      e.preventDefault();
    });
    
    viewport.addEventListener('mouseleave', () => {
      if (isDragging) {
        isDragging = false;
        viewport.style.cursor = 'grab';
        handleDragEnd();
      }
    });
    
    viewport.addEventListener('mouseup', (e) => {
      if (isDragging) {
        isDragging = false;
        viewport.style.cursor = 'grab';
        handleDragEnd();
      }
    });
    
    viewport.addEventListener('mousemove', (e) => {
      if (isDragging) {
        const diff = dragStartX - e.clientX;
        const sliderContainer = slider.querySelector('.hdt-slider__container');
        if (sliderContainer) {
          // NO TRANSITION - instant movement
          sliderContainer.style.transition = 'none';
          const newTranslate = initialTranslate - diff;
          sliderContainer.style.transform = `translateX(${newTranslate}px)`;
        }
      }
    });
  }
  
  const handleSwipe = () => {
    const diff = touchStartX - touchEndX;
    const threshold = 50; // Minimum distance for swipe
    
    if (Math.abs(diff) > threshold) {
      const totalPages = Math.ceil(slides.length / calculateSlidesPerView(slider));
      
      if (diff > 0) {
        // Swipe left - next page
        if (currentPageIndex < totalPages - 1) {
          currentPageIndex = navigateToPage(currentPageIndex + 1);
        }
      } else {
        // Swipe right - previous page
        if (currentPageIndex > 0) {
          currentPageIndex = navigateToPage(currentPageIndex - 1);
        }
      }
    } else {
      // If swipe wasn't enough, return to current page
      navigateToPage(currentPageIndex);
    }
  };
  
  const handleDragEnd = () => {
    const sliderContainer = slider.querySelector('.hdt-slider__container');
    if (!sliderContainer) return;
    
    const currentTransform = sliderContainer.style.transform;
    if (currentTransform) {
      const match = currentTransform.match(/translateX\((-?\d+\.?\d*)px\)/);
      if (match) {
        const currentTranslate = parseFloat(match[1]);
        const slidesPerView = calculateSlidesPerView(slider);
        const firstSlide = slides[0];
        if (!firstSlide) return;
        
        const slideWidth = firstSlide.offsetWidth;
        const expectedTranslate = -(currentPageIndex * slidesPerView * slideWidth);
        const diff = Math.abs(currentTranslate - expectedTranslate);
        const threshold = slideWidth * 0.3; // 30% of slide width
        
        if (diff > threshold) {
          // Determine if we should go to next or previous page
          if (currentTranslate < expectedTranslate) {
            // Dragged left, go to next page
            const totalPages = Math.ceil(slides.length / slidesPerView);
            if (currentPageIndex < totalPages - 1) {
              currentPageIndex = navigateToPage(currentPageIndex + 1);
            } else {
              currentPageIndex = navigateToPage(currentPageIndex);
            }
          } else {
            // Dragged right, go to previous page
            if (currentPageIndex > 0) {
              currentPageIndex = navigateToPage(currentPageIndex - 1);
            } else {
              currentPageIndex = navigateToPage(currentPageIndex);
            }
          }
        } else {
          // Return to current page
          currentPageIndex = navigateToPage(currentPageIndex);
        }
      }
    }
  };
}
